export default {
  "header.language": "语言",
  "Log in": "登录",
  "Sign Up": "注册",
  "Buy Crypto": "买币",
  "header.quicktrade": "快捷买币",
  "header.quicktrade.desc": "通过银行卡快速买卖虚拟资产",
  "header.C2C": "P2P交易",
  "header.C2C.desc": "简单操作，快速交易，开启交易第一步",
  "header.u.account": "账号管理",
  "header.u.fee": "我的费率",
  "header.u.bonus": "我的赠金",
  "header.u.c2c": "P2P设置",
  "header.u.invite": "邀请好友",
  "header.u.api": "API管理",
  "header.u.logout": "退出",
  Market: "行情",
  Spot: "币币交易",
  Futures: "合约交易",
  koltrade: "合约跟单",
  Bonus: "合约赠金",
  Agent: "全球代理人",
  more: "查看更多",
  "Perpetual Contract": "永续",
  "header.assets": "资产",
  "header.order": "订单",
  totalAssets: "资产总览",
  exchangeAccount: "现货账户",
  otcAccount: "P2P账户",
  coAccount: "合约账户",
  exchangeOrder: "现货订单",
  otcOrder: "P2P订单",
  coOrder: "合约订单",
  "header.appDownLoad": "扫描下载APP",
  "header.moreload": "更多下载选项",
  "header.rate": "汇率",
  "index.banner.2": "最懂你的AI智能交易所",
  "Register Now": "立即注册",
  "Trade Now": "立即交易",
  "index.register.type": "邮箱/手机号码",
  "index.banner.desc": "注册领取最高{amount}任务奖励",
  "index.text1": "卓越的",
  "index.text2": "现货流动性",
  "index.text3": "合约流动性",
  "index.text4": "盘口价差",
  "index.text5": "盘口厚度",
  "index.text6": "行业排名",
  "index.c4.title": "专业且易于使用",
  "index.c4.title2": "VOOX提供适合所有交易者的加密货币平台",
  "index.c4.t1.t": "现货交易",
  "index.c4.t1.p": "交易BTC、ETH、USDT等主流加密货币，享受卓越流动性和快速执行",
  "index.c4.t2.t": "合约交易",
  "index.c4.t2.p": "透过灵活的杠杆合约交易，扩展您的交易潜力",
  "index.c4.t3.t": "跟单交易",
  "index.c4.t3.p": "跟单顶级交易员，掌握市场趋势，轻松优化您的交易策略",
  "index.c5.title": "在VOOX轻松赚钱",
  "index.c5.title2": "在VOOX的直观平台上解锁加密货币交易的力量",
  "index.c5.t1.t": "在VOOX体验零成本的期货交易",
  "index.c5.t1.p":
    "透过我们丰富的赠金活动，帮助您迅速掌握合约交易，轻松小赚一笔",
  "index.c5.t2.t": "与高手一起智慧盈利",
  "index.c5.t2.p":
    "我们先进的跟单交易平台将您与顶尖交易者连接。只需委托，坐享其成",
  "index.c6.title": "极致的安全",
  "index.c6.title2": "VOOX全天候保护您的资产",
  "index.c6.1.t": "全面审计",
  "index.c6.1.p":
    "VOOX执行全面审计，确保我们平台的完整性与安全，让每一笔交易都透明可信",
  "index.c6.2.t": "加密托管合作",
  "index.c6.2.p":
    "VOOX与顶尖的加密资产托管商合作，提升用户资产的安全性。我们的合作是基于对最高安全标准和资产保护的承诺",
  "index.c6.3.t": "安全冷存储",
  "index.c6.3.p":
    "VOOX使用安全的冷存储解决决方案来保护您的数字资产，最小化风险，确保您的资金免受未授权访问",
  "index.c6.4.t": "合法合规",
  "index.c6.4.p":
    "VOOX严格遵守法律和监管标准，确保所有操作都合法合规，为我们的用户提供一个安全的交易环境",
  "c7.title": "无缝交易体验",
  "c7.title2": "随时随地通过VOOX的手机和网页平台访问全球加密市场",
  c7_qrcode: "扫码下载APP",
  c7_qrcode1: "下载 VOOX Android/iOS APP",
  "c8.title": "开始您的加密货币之旅",
  "c8.title2": "VOOX的AI驱动洞察让您更智慧地交易，赚取更多收益",
  "footer.contractus": "联系我们",
  "footer.media": "社群社媒",
  "footer.downloadapp": "下载App",
  "footer.product": "产品",
  "footer.creditCardPurchase": "快捷买币",
  "footer.c2c": "C2C买币",
  "footer.trade": "现货交易",
  "footer.futures": "合约交易",
  "footer.futures": "合约交易",
  "footer.koltrade": "合约跟单",
  "footer.bonus": "合约赠金",
  "footer.business": "服务",
  "footer.cms.apply": "上币申请",
  "footer.agent.apply": "代理申请",
  "footer.c2c.apply": "C2C商家申请",
  "footer.support": "支持",
  "footer.mesage": "公告中心",
  "footer.help": "帮助中心",
  "footer.fee": "费率中心",
  "footer.about": "关于我们",
  "footer.agreement": "用户协议",
  "footer.privacy": "隐私政策",
  "footer.disclaimer": "反洗钱政策",
  "footer.companyname": "公司名称: VOOX Limited",
  "footer.companynumber": "公司注册号: 20241849145",
  "footer.companyaddress":
    "公司地址: 1312 17th Street, Unit Num 2955, Denver, CO 80202, United States",
  "footer.customerService": "客服中心",
  "footer.requests": "提交工单",
  "footer.officialVerify": "官方验证通道",
  Notice: "公告",
  "notFound.title": "404 | VOOX",
  "notFound.desc": "抱歉，您访问的页面不存在。",
  "notFound.backHome": "返回首页",
};
